<template>
    <v-card>
        <v-card-title>
            Line Notify 綁定
        </v-card-title>
    </v-card>
</template>

<script>
	export default {
		name: 'LineNotifyCallBack',
		components: {

		}, 	
        data: function() {
            return {
                is_show: true,
                is_success: false,
                alert_type: 'success'
            }
        },
        methods: {
            close: function(){
                this.is_show = false
            },
            fail(){
                if (process.env.VUE_APP_MODE === 'production'){
                    window.location.href = process.env.VUE_APP_HOME_PAGE + '/signout'
                }
                else {
                    this.$router.push('/redirect')
                }
            }
        },
        created: async function(){
            let code = this.$route.query.code
            let state = this.$route.query.state

            if (!code || !state) {
                this.$router.push('/redirect')
                return
            }

            if (state.split('-').length !== 2) {
                this.$router.push('/redirect')
                return
            }

            console.log(code)
            console.log(state)

            let org_id = state.split('-')[0]
            let container_id = state.split('-')[1]
            this.$router.replace(`/${org_id}/setting/containers/${container_id}/edit?callback=line&code=${code}`)
        },
        mounted: function(){
            
        }
    }
</script>